var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPptFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    rx: 6,
    fill: "#EEAB46"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.0499 23.1328H25.2147V13.5534H21.9556V12H30.3014V13.5534H27.0499V23.1328Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.831 12C18.2677 12 19.316 12.2944 19.9759 12.8833C20.6359 13.4722 20.9658 14.2971 20.9658 15.3581C20.9658 15.8404 20.8897 16.2998 20.7374 16.7364C20.5902 17.1679 20.3465 17.5512 20.0064 17.8862C19.6662 18.2162 19.217 18.4776 18.6586 18.6705C18.1052 18.8635 17.4224 18.9599 16.6102 18.9599H15.4223V23.1328H13.5947V12H16.831ZM16.7092 13.5153H15.4223V17.437H16.4198C16.9935 17.437 17.4808 17.371 17.8818 17.239C18.2829 17.1019 18.5875 16.8862 18.7956 16.5917C19.0038 16.2973 19.1078 15.9089 19.1078 15.4267C19.1078 14.7819 18.9124 14.3022 18.5215 13.9875C18.1357 13.6727 17.5316 13.5153 16.7092 13.5153Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.23628 12C8.67294 12 9.72124 12.2944 10.3812 12.8833C11.0411 13.4722 11.3711 14.2971 11.3711 15.3581C11.3711 15.8404 11.295 16.2998 11.1427 16.7364C10.9954 17.1679 10.7518 17.5512 10.4116 17.8862C10.0715 18.2162 9.62225 18.4776 9.06383 18.6705C8.51049 18.8635 7.8277 18.9599 7.01545 18.9599H5.82755V23.1328H4V12H7.23628ZM7.11445 13.5153H5.82755V17.437H6.82508C7.39873 17.437 7.88608 17.371 8.28712 17.239C8.68817 17.1019 8.99276 16.8862 9.2009 16.5917C9.40903 16.2973 9.5131 15.9089 9.5131 15.4267C9.5131 14.7819 9.31766 14.3022 8.92676 13.9875C8.54095 13.6727 7.93684 13.5153 7.11445 13.5153Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPptFile);
export default __webpack_public_path__ + "static/media/ppt-file.d7c64d28ceb3fe4fea95db0a72206b4f.svg";
export { ForwardRef as ReactComponent };